
    import { defineComponent } from 'vue'
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import GoodTypesService from '@/apps/shared/services/goodTypes-service';
    import ProductCardsSelector from '@/apps/shared/components/ProductCardsSelector.vue';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    export default defineComponent({
        components: {
            XBreadcrumb,
            ProductCardsSelector,
        },
        busEvents: {
            Next: function (data) {
                //prevenir que el evento Next y otras acciones de navegación se ejecuten de forma redundante.
                if (data.fromTab === 'tab-two') {
                    if (this.$refs.productCards && this.$refs.productCards.isNavigationAllowed) {  // Comprobamos si la navegación está permitida
                        this.$router.push({
                            name: 'electronic-equipment-range-view',
                        });
                        this.$refs.productCards.isNavigationAllowed = false;  // Desactivamos la navegación
                    }
                }
            },
            SaveProductDataValueSession: function (value) {
                if (value.fromTab === 'tab-two') {
                    sessionStorage.removeItem('ProductDataSelected');
                    sessionStorage.setItem('ProductDataSelected', JSON.stringify(value));
                }
            },
        },
        data() {
            return {
                productCardsSelector: {
                    iconPromotion: null,
                    otherIconPromotion: null,
                    icon: null,
                    product: "",
                    title: "¿Qué necesitás cotizar?",
                    subTitle: "Elegí una opción para comenzar.",
                    tabName: "tab-two",
                } as TitleAndPromotionsDetails,
                breadcrumItems: [
                    { text: 'Inicio', path: '/tecnologia' },
                    { text: 'Equipos Electrónico', path: '/tecnologia/cotizarEquipoElectronico' },
                ],
                validBack: false,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Tecnología';
                const actualPath = '/tecnologia';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultElectronicDeviceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            getGoodTypes: function () {
                var productId = 1000;
                var securityGroup = '';
                let userName = '';
                let userToken = '';
                let tokenType = "";
                let correlationInformation = "";
                let onDate = new Date().toISOString();
                GoodTypesService.getGoodTypes(productId, securityGroup, onDate, correlationInformation, userName, userToken, tokenType)
                    .then(response => {
                        var goods = response.map(element => ({
                            ...element,
                            code: element["goodTypeId"],
                            productDescription: element["goodTypeDescription"],
                            hasProductNoteValue: element["notes"] == "" ? false : true,
                        }));
                        this.$refs.productCards.setProductData(goods);
                        NF.UI.Page.unblock();
                    })
            },

            volver() {
                NF.UI.Page.block();
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'electronic-equipment-tab-One',
                })
            },
            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                this.getGoodTypes();
                this.validBack = sessionStorage.getItem("pressBack");
                if (this.validBack) {
                    // Permite la navegación nuevamente cuando el componente regresa a este tab
                    this.$refs.productCards.resetNavigationFlag();
                    var productData = JSON.parse(sessionStorage.getItem("ProductDataSelected"));
                    if (productData) {
                        //Llama a la funcion de productCardsSelector.vue, luego de que regresan la pantalla y muestra la opcion elegida
                        this.$refs.productCards.getDataProductBack(productData);
                    }
                    sessionStorage.removeItem("pressBack");
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                const parallelPromises = [
                    this.pageCustomization(),
                    this.updateByProductGoogleAnalytics(),
                    this.getInitData()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);


            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
